import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { ProductCentralLogo } from './-components/ProductCentralLogo';
export const Route = createFileRoute('/_stacktrace/products/_layout')({
  component: Layout
});

/**
 * プロダクト（Product Central > プロダクト）一覧のレイアウト。
 *
 * 上部タブ構成: 概要 / プロダクト / 公開終了 / アラート / 運用 / 設定。
 * 概要・アラート・運用・設定は将来追加予定のため disabled の予約タブ。
 * 「公開終了」は「プロダクト」の次に置く読み取り専用タブ（People の退職者相当）。
 * `to` は LinkProps の型上必須なので、未実装パスは `as never` でキャストする。
 */
function Layout() {
  const {
    t
  } = useTranslation();
  const {
    t: tStacktrace
  } = useTranslation(stacktraceNS);
  const title = tStacktrace('products.title');
  useDocumentTitle(title);
  const tabs = [{
    to: '/products/overview' as never,
    children: t('common.list.overview'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/products',
    children: tStacktrace('products.list.tabLabel'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/products/published-ended',
    children: tStacktrace('products.list.publishEnded.tabLabel'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/products/alerts' as never,
    children: t('common.list.alerts'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/products/operation-activity' as never,
    children: t('common.list.operationActivity'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/products/rules-and-policy' as never,
    children: t('common.list.configuration'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/products/settings' as never,
    children: t('common.list.settings'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <ProductHeader Logo={ProductCentralLogo} name={title} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}